var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.3962 1.73145H16.2178C17.3864 1.73145 18.3333 2.68632 18.3333 3.86475V6.71022C18.3333 7.88864 17.3864 8.84352 16.2178 8.84352H13.3962C12.2276 8.84352 11.2808 7.88864 11.2808 6.71022V3.86475C11.2808 2.68632 12.2276 1.73145 13.3962 1.73145",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78194 1.73145H6.60358C7.77214 1.73145 8.71902 2.68632 8.71902 3.86475V6.71022C8.71902 7.88864 7.77214 8.84352 6.60358 8.84352H3.78194C2.61338 8.84352 1.6665 7.88864 1.6665 6.71022V3.86475C1.6665 2.68632 2.61338 1.73145 3.78194 1.73145ZM3.78194 11.286H6.60358C7.77214 11.286 8.71902 12.2409 8.71902 13.4193V16.2648C8.71902 17.4424 7.77214 18.3981 6.60358 18.3981H3.78194C2.61338 18.3981 1.6665 17.4424 1.6665 16.2648V13.4193C1.6665 12.2409 2.61338 11.286 3.78194 11.286ZM16.2177 11.286H13.3961C12.2275 11.286 11.2807 12.2409 11.2807 13.4193V16.2648C11.2807 17.4424 12.2275 18.3981 13.3961 18.3981H16.2177C17.3863 18.3981 18.3332 17.4424 18.3332 16.2648V13.4193C18.3332 12.2409 17.3863 11.286 16.2177 11.286Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBlack);
export default __webpack_public_path__ + "static/media/dashboard-black.be6d566e303179c02ccb2336ce65c502.svg";
export { ForwardRef as ReactComponent };